export function getStartAndEndOfDayUTC(date: string | Date): { startUTC: Date; endUTC: Date } {
    if (!date) {
      throw new Error("Fecha inválida");
    }
  
    //const startDateLocal = new Date(new Date(date).setHours(0, 0, 0, 0));
    //const startDateUTC = new Date(startDateLocal.getTime() - startDateLocal.getTimezoneOffset() * 60000).toISOString(); // Convertir ambos a UTC ISO

    const localDate = new Date(date);
    const localOffset = localDate.getTimezoneOffset() * 60000; // Offset en milisegundos
  
    // Inicio del día en UTC
    const adjustedSelectedDateStart = new Date(localDate);
    adjustedSelectedDateStart.setHours(0, 0, 0, 0);
    const localMidnightUTC = adjustedSelectedDateStart.getTime() - localOffset;
    const adjustedStart = new Date(localMidnightUTC);
  
    // Fin del día en UTC
    const adjustedSelectedDateEnd = new Date(localDate);
    adjustedSelectedDateEnd.setHours(23, 59, 59, 999);
    const localEndOfDayUTC = adjustedSelectedDateEnd.getTime() - localOffset;
    const adjustedEnd = new Date(localEndOfDayUTC);
  
    return { startUTC: adjustedStart, endUTC: adjustedEnd };
}
  